// Renders the official GlassCore logo.
// `dark=false` (default) → primary dark-ink logo on transparent (for light backgrounds).
// `dark=true` → white version for dark backgrounds (navy hero, footer, panels).
export default function LogoMark({ className = "h-10 w-auto", dark = false, alt = "GlassCore" }) {
  const src = dark
    ? "/assets/glasscore-dark.png?v=3"
    : "/assets/glasscore-primary.png?v=3";
  return (
    <img
      src={src}
      alt={alt}
      className={`${className} select-none`}
      draggable="false"
    />
  );
}
